"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverseThroughDataObjects = void 0;
var realms_engine_1 = require("realms-engine");
var realmsEditor_model_1 = require("../realmsEditor.model");
/**
 * Traverse through all data objects in a realm blueprint. All blueprintRefs are automatically
 * broken into sub dataObjects
 */
function traverseThroughDataObjects(realmBlueprint, callback) {
    var e_1, _a;
    // Map blueprint id to all their dataobjects
    var blueprintDataObjectsMap = new Map();
    try {
        for (var _b = __values(realmBlueprint.dataObjects), _c = _b.next(); !_c.done; _c = _b.next()) {
            var dataObject = _c.value;
            var dataObjects = blueprintDataObjectsMap.get(dataObject.blueprintId);
            if (!dataObjects) {
                blueprintDataObjectsMap.set(dataObject.blueprintId, [dataObject]);
            }
            else {
                dataObjects.push(dataObject);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var traverse = function (blueprintId, _a) {
        var e_2, _b;
        var parentScale = _a.parentScale, parentPosition = _a.parentPosition, parentQuaternion = _a.parentQuaternion;
        var dataObjects = blueprintDataObjectsMap.get(blueprintId);
        if (!dataObjects) {
            return;
        }
        try {
            for (var dataObjects_1 = __values(dataObjects), dataObjects_1_1 = dataObjects_1.next(); !dataObjects_1_1.done; dataObjects_1_1 = dataObjects_1.next()) {
                var dataObject = dataObjects_1_1.value;
                var worldScale = (dataObject.worldTransformation.worldScale.x +
                    dataObject.worldTransformation.worldScale.y +
                    dataObject.worldTransformation.worldScale.z) /
                    3;
                var worldPosition = dataObject.worldTransformation.worldPosition;
                var worldQuaternion = dataObject.worldTransformation.worldQuaternion;
                var globalScale = worldScale * parentScale;
                var globalPosition = (0, realms_engine_1.vector3Add)((0, realms_engine_1.vector3ApplyQuat)((0, realms_engine_1.vector3Multiply)(worldPosition, worldScale), parentQuaternion), parentPosition);
                var globalQuaternion = (0, realms_engine_1.quatMultiply)(parentQuaternion, worldQuaternion);
                // Breakdown
                if (dataObject.type === realmsEditor_model_1.DataObjectType.BlueprintRef) {
                    traverse(dataObject.ref.blueprintId, {
                        parentScale: globalScale,
                        parentPosition: globalPosition,
                        parentQuaternion: globalQuaternion,
                    });
                    continue;
                }
                // Handle
                callback({ dataObject: dataObject, globalScale: globalScale, globalPosition: globalPosition, globalQuaternion: globalQuaternion });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (dataObjects_1_1 && !dataObjects_1_1.done && (_b = dataObjects_1.return)) _b.call(dataObjects_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    traverse(realmBlueprint.rootBlueprintId, {
        parentScale: 1,
        parentPosition: (0, realms_engine_1.vector3Zero)(),
        parentQuaternion: (0, realms_engine_1.quatZero)(),
    });
}
exports.traverseThroughDataObjects = traverseThroughDataObjects;
